<template>
  <div>
    <template v-if="isSafari">
      <safari-Blocked/>
    </template>
    <template v-else>
      <div class="container-fluid">
        <div class="flex">
          <blinki-header :class="{'header-mini-menu':!fullMenu}"/>
          <sidebar v-if="menuShow" :full="fullMenu"/>
          <main role="main" class="col-md-9 ml-sm-auto col-lg-10 px-4 p-top"
                :class="{'main-mini-menu':(!fullMenu || !menuShow) , 'full-menu':fullMenu}">
            <nuxt :class="{'mini-body':(!fullMenu || !menuShow)}" class="body-nuxt-div"/>
            <!--<blinki-footer />-->
          </main>
        </div>
      </div>
      <confirm/>
      <vue-confirm-dialog/>
    </template>
  </div>
</template>

<script>
  import blinkiHeader from '~/components/template/shared/header';
  import blinkiFooter from '~/components/template/shared/footer';
  import sidebar from '~/components/template/shared/sidebar';
  import confirm from '../components/popups/confirm';
  import safariBlocked from '~/components/template/modules/safari-blocked';
  import {getLoggedUser} from "@/helpers";

  export default {
    middleware: 'authenticated',
    name: 'main-layout',
    data() {
      return {
        full_menu: true
      }
    },
    components: {
      blinkiFooter,
      blinkiHeader,
      sidebar,
      confirm,
      safariBlocked,
    },
    computed: {
      menuShow(){
       return  getLoggedUser().role !== 'MARQUE';
      },
      fullMenu() {
        return this.$store.state.theme.fullSideBar;
      },
      isSafari() {
        let ua = navigator.userAgent.toLowerCase();
        return ua.indexOf("safari") != -1 && ua.indexOf("chrome") == -1;
      }
    },
    watch: {
      $route(to, from) {
        localStorage.setItem('CLIENT_PAGE', 1);
      }
    },
  }

</script>

<style lang="scss">
  @import '~/assets/css/theme.scss';

  body {
    font-size: .875rem;
  }

  .feather {
    width: 16px;
    height: 16px;
    vertical-align: text-bottom;
  }

  /*
   * Sidebar
   */

  .sidebar {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 100; /* Behind the navbar */
    padding: 48px 0 0; /* Height of navbar */
    box-shadow: inset -1px 0 0 rgba(0, 0, 0, .1);
  }

  .sidebar-sticky {
    position: relative;
    top: 0;
    height: calc(100vh - 25px);
    padding-top: .5rem;
    overflow-x: hidden;
    overflow-y: auto; /* Scrollable contents if viewport is shorter than content. */
    padding-bottom: 20px;
  }

  @supports ((position: -webkit-sticky) or (position: sticky)) {
    .sidebar-sticky {
      position: -webkit-sticky;
      position: sticky;
    }
  }

  .sidebar .nav-link {
    font-weight: 500;
    color: #333;
  }

  .sidebar .nav-link .feather {
    margin-right: 4px;
    color: #999;
  }

  .sidebar .nav-link.active {
    color: #007bff;
  }

  .sidebar .nav-link:hover .feather,
  .sidebar .nav-link.active .feather {
    color: inherit;
  }

  .sidebar-heading {
    font-size: .75rem;
    text-transform: uppercase;
  }

  /*
   * Content
   */

  [role="main"] {
    padding-top: 133px; /* Space for fixed navbar */
  }

  @media (min-width: 768px) {
    [role="main"] {
      padding-top: 48px; /* Space for fixed navbar */
    }
  }

  /*
   * Navbar
   */

  .navbar-brand {
    padding-top: .75rem;
    padding-bottom: .75rem;
    font-size: 1rem;
    background-color: rgba(0, 0, 0, .25);
    box-shadow: inset -1px 0 0 rgba(0, 0, 0, .25);
  }

  .navbar .form-control {
    padding: .75rem 1rem;
    border-width: 0;
    border-radius: 0;
  }

  .form-control-dark {
    color: #fff;
    background-color: rgba(255, 255, 255, .1);
    border-color: rgba(255, 255, 255, .1);
  }

  .form-control-dark:focus {
    border-color: transparent;
    box-shadow: 0 0 0 3px rgba(255, 255, 255, .25);
  }

  .p-top {
    padding-top: 71px !important;
  }

  .body-nuxt-div {
    width: calc(100vw - 380px) !important;
  }

  .main-mini-menu .body-nuxt-div.mini-body {
    width: calc(100vw - 120px) !important;
  }

  .container-fluid {
    padding: 0 !important;
  }
  main.full-menu{
    margin-left: 314px !important;
  }

</style>
